import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { ProjectService } from "src/app/_services/project.service";
import { SubscriptionUtil } from "src/app/_utilities/subscription";

@Component({
    selector: "app-custella-projects",
    templateUrl: "./custella-projects.component.html",
    styleUrls: ["./custella-projects.component.scss"],
    standalone: false
})
export class CustellaProjectsComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  @Output() itemSelector = new EventEmitter();
  @Output() closeView = new EventEmitter();
  @Input() projectIdsToSkip: any[] | null = null;
  @Input() customerId: any = null;
  @Input() siteId: any = null;
  @Input() assetsId: any = null;

  public searchValue = "";
  translate: any;

  constructor(private projecService: ProjectService,
    private languageTranslateService: LanguageTranslateService
  ) {
    super();
this.push(      this.languageTranslateService.menuSrc$.subscribe(data => {
  if(Object.keys(data).length != 0){ this.translate = data}
}))
    this.push(
      this.projecService.getSelectItem().subscribe((data) => {
        if (data) {
          this.selectItem(data);
        }
      })
    );
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  selectItem(val: any) {
    this.itemSelector.emit(val);
  }

  public closeTable() {
    this.closeView.emit(false);
  }
   
  push(obs:any) {
    super.push(obs);
  }
}
